import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFound from "./config/tokenNotFound";
import { CreateBoardResponse } from "../../api/board";

type Body = {
    title: string,
    content: string,
    board_category_id: number,
    image_urls: string[],
}

export type TApiCreateBoardResult = {
  result?: CreateBoardResponse;
};

export const postBoard = async (
    body: Body
): Promise<TApiResult  & TApiCreateBoardResult> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;
  const {
    title,
    content,
    board_category_id,
    image_urls
  } = body

  return await client()
    .board.post({
      body: {
        title,
        content,
        board_category_id,
        image_urls
      },
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "postBoard");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
